import russianMessages from 'ra-language-russian';

import customRussianMessages from './rus';

export default {
  rus: { ...russianMessages, ...customRussianMessages },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js